import React, { useState, useEffect, useContext } from 'react';
import './FighterPage.css';
import FighterModifierScale from './FighterModifierScale';
import FighterFactionSelector from './Mounting/FighterSelector';
import { BASE_URL } from '../../../config';
import UserContext from '../../../UserContext';
import defaultImg from '../static.gif';

const modifiers = [
    { name: 'Ammo Loaded', value: 0 },
    { name: 'Armor Installed', value: 0 },
    { name: 'Laser Damage', value: 0 },
    { name: 'Secondary Weapon', value: 0 },
    { name: 'Missile Damage', value: 0 },
    { name: 'Vertical Control', value: 0 },
    { name: 'Horizontal Control', value: 0 },
];

const DEFAULT_IMAGE = defaultImg;

const FighterPage = ({ onClose }) => {
    const [showFactionSelector, setShowFactionSelector] = useState(false);
    const { userInfo } = useContext(UserContext) || {};
    const [fighterImage, setFighterImage] = useState(DEFAULT_IMAGE);
    const [mountedStats, setMountedStats] = useState(null);
    const [refreshKey, setRefreshKey] = useState(0);

    const handleFighterChanged = () => {
        setShowFactionSelector(false); // This closes the FighterSelector modal
        setRefreshKey(prev => prev + 1); // Trigger a refresh
    };

    useEffect(() => {
        const fetchMountedStatsAndImage = async () => {
            if (!userInfo || !userInfo.wallet_address || !userInfo.jwt) return;
            try {
                // Step 1: Get mounted stats
                const statsRes = await fetch(`${BASE_URL}/get_mounted_stats`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        address: userInfo.wallet_address,
                        jwt: userInfo.jwt
                    }),
                });
                const stats = await statsRes.json();
                setMountedStats(stats); // <-- store all stats
                console.log('[FighterPage] Mounted NFT stats:', stats);

                // Step 2: Fetch image (same as before)
                if (
                    stats &&
                    stats.is_mounted &&
                    stats.collection &&
                    (stats.token_id || stats.metadata?.edition)
                ) {
                    const nft_contract = stats.collection;
                    const nft_id = String(stats.token_id || stats.metadata?.edition || '');
                    const imageRes = await fetch(`${BASE_URL}/get_user_nft_image`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            address: userInfo.wallet_address,
                            jwt: userInfo.jwt,
                            nft_contract: nft_contract,
                            nft_id: nft_id,
                        }),
                    });

                    if (imageRes.ok) {
                        const imgBlob = await imageRes.blob();
                        const imgURL = URL.createObjectURL(imgBlob);
                        setFighterImage(imgURL);
                        console.log('[FighterPage] Fighter image loaded as blob');
                    } else {
                        setFighterImage(DEFAULT_IMAGE);
                        console.warn('[FighterPage] No fighter image found for mounted NFT.');
                    }
                } else {
                    setFighterImage(DEFAULT_IMAGE);
                }
            } catch (err) {
                setMountedStats(null);
                setFighterImage(DEFAULT_IMAGE);
                console.error('[FighterPage] Error fetching mounted fighter stats or image:', err);
            }
        };
        fetchMountedStatsAndImage();
    }, [userInfo, refreshKey]);

    return (
        <div className="fighterpage-container">
            {/* <button className="fighterpage-close-button" onClick={onClose}>{'\u00D7'}</button> */}
            <div className="fighterpage-main-row">
                <div className="fighterpage-image-container">
                    <img
                        src={fighterImage}
                        alt="NoImageAvailable"
                        className="fighterpage-image"
                    />
                </div>
                <div className="fighterpage-actions-container">
                    <button
                        className="fighterpage-action-main"
                        onClick={() => setShowFactionSelector(true)}
                    >
                        Available Fighters
                    </button>
                    <div className="fighterpage-action-grid">
                        <button className="fighterpage-action">Load Ammo</button>
                        <button className="fighterpage-action">Repair Armor</button>
                        <button className="fighterpage-action">Attach Equipment</button>
                    </div>
                </div>
            </div>
            <div className="fighterpage-modifiers-container">
                <h3 className="fighterpage-section-title">In Game Fighter Information</h3>
                <div className="fighterpage-modifiers-list">
                    {[
                        { key: "Ammo", label: "Ammo Loaded" },
                        { key: "Armor", label: "Armor Installed" },
                        { key: "Laser Damage", label: "Laser Damage" },
                        { key: "Secondary Weapon", label: "Secondary Weapon" },
                        { key: "Missile Damage", label: "Missile Damage" },
                        { key: "Vertical Control", label: "Vertical Control" },
                        { key: "Horizontal Control", label: "Horizontal Control" },
                    ].map(({ key, label }) => (
                        <div className="fighterpage-modifier" key={key}>
                            <FighterModifierScale
                                value={mountedStats?.modifiers?.[key]?.value ?? 0}
                                label={label}
                                classLabel={mountedStats?.modifiers?.[key]?.class
                                    ? `class ${mountedStats.modifiers[key].class}`
                                    : "class 1"
                                }
                            />
                        </div>
                    ))}
                </div>
            </div>
            {showFactionSelector && (
                <FighterFactionSelector
                    onClose={() => setShowFactionSelector(false)}
                    onMountChange={handleFighterChanged}
                />
            )}
        </div>
    );
};

export default FighterPage;
